/**
 * @author xiaohuangmaoth
 * @description 考试成绩明细
 * @Date 2021/03/02
 */
import React from "react";
import { connect } from "dva";
import { framework_tool, component_tool } from "@/tool";
import { templateConfig, reduxTemplateCofig } from "./config";
import column from './column';

const { WizContainer, WizReduxTemplate } = framework_tool;
const { WizBrowserExport } = component_tool

let formatTime = (time,record) => {
  let limitMinutesSeconds = record && record.limitMinutes ? record.limitMinutes * 60 : 0
  if(time > limitMinutesSeconds) {
    time = limitMinutesSeconds
  }
  // 转换为时分秒
  let h = parseInt(time / 60 / 60 % 24)
  let m = parseInt(time / 60 % 60)
  let s = parseInt(time % 60)
   let res = ''
   if (h > 0) {res += `${h}时`};
   if (m > 0) {res += `${m}分`};
   if (s > 0) {res += `${s}秒`};
  return res
}

const _getValue = (type, key) => {
  const values = {
    examType: {
      '0': '独立考试',
      '1': '课程考试',
      '0,1': '独立考试、课程考试',
      '1,0': '独立考试、课程考试'
    }
  }
  return values[type][key] || ''
}

class ExamScoreStatistics extends WizContainer {
  componentName = "ExamScoreStatistics";

  handleFile(nextProps, nextState, key) {
    const res = nextProps[key]
    const { success, data = [], msg } = res

    if (success) {
      const rows = data.map(val => ({
        ...val,
        duration: formatTime(val.duration, val),
        examType: _getValue('examType', val['examType']),
        status : val.status ? '已发布' :'已关闭',
        accountState: val.accountState ? '激活' :'禁用',
        jobState: val.jobState!=null && val.jobState===1 ? '在职' :val.jobState!=null && val.jobState===0  ? '离职': '',
        pass: val.pass ? '通过' :'未通过',
      }))

      const title = '考试成绩明细'

      WizBrowserExport({
        title,
        sheetName: title,
        columns: column.filter((_, index) => index),
        rows,
        filename: title + '.xlsx',
      })
      return true

    } else {
      wizNotice.error(msg)
      return false;
    }

  }

  _render() {
    const _reduxTemplateCofig = reduxTemplateCofig({
      templateConfig: templateConfig.call(this),
      apiDataFormat: {
        export: this.handleFile
      },
    });

    return <WizReduxTemplate {..._reduxTemplateCofig} />
  }
}

export default connect(() => ({}))(ExamScoreStatistics);
